'use es6';

import get from 'transmute/get';
export const isActiveHubSpotOwner = owner => {
  return Boolean(get('activeUserId', owner));
};
export const isOnlyActiveSalesforceOwner = owner => {
  return Boolean(get('activeSalesforceId', owner)) && !isActiveHubSpotOwner(owner);
};